<template>
  <BaseModalSmall
    testId="warning"
    @close="close"
  >
    <BaseText size="l">{{ data.message }}</BaseText>
    <template #center>
      <BaseText v-if="data.subMessage">{{ data.subMessage }}</BaseText>
      <BaseText
        v-if="data.learnMoreLink"
        :href="data.learnMoreLink"
      >
        {{ $t('global.learn_more') }}
      </BaseText>
    </template>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="close"
      >
        {{ $t('global.actions.close') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  setup
  lang="ts"
>
interface Props {
  data: {
    message: string;
    subMessage?: string;
    learnMoreLink?: string;
  };
}

defineProps<Props>();

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>
